import { render, staticRenderFns } from "./MenuLabel.vue?vue&type=template&id=aa0120e0&"
var script = {}
import style0 from "./MenuLabel.vue?vue&type=style&index=0&id=aa0120e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports